import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Box, Typography, Button, Card, Link, CircularProgress, Divider, CardContent} from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DownloadIcon from '@mui/icons-material/Download';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const ResultsDisplay = ({ results }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);

  // useEffect para gerar o QR Code quando a URL parametrizada mudar
  useEffect(() => {
    if (results?.fullUrl && results.fullUrl.trim() !== '') {
      setIsGenerating(true);
      setQrCodeDataUrl('');
  
        // Gera o QR Code usando a biblioteca qrcode
      QRCode.toDataURL(results.fullUrl, {
        width: 200,
        margin: 2,
        color: { 
          dark: '#000000',
          light: '#FFFFFF' 
        },
      })
        .then((dataUrl) => {
          setQrCodeDataUrl(dataUrl);
          setIsGenerating(false);
        })
        .catch((error) => {
          console.error('Erro ao gerar QR Code:', error);
          setIsGenerating(false);
          toast.error('Erro ao gerar o QR Code.');
        });
    }
  }, [results?.fullUrl]);

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success('URL copiada para a área de transferência!');
    } catch (err) {
      console.error('Falha ao copiar:', err);
      toast.error('Erro ao copiar URL.');
    }
  };

  // Função para fazer download do QR Code em alta resolução
  const downloadQRCode = async () => {
    if (results?.fullUrl && results.fullUrl.trim() !== '') {
      try {
        // Gera QR Code em alta resolução para download
        const highResQRCode = await QRCode.toDataURL(results.fullUrl, {
          width: 1200,
          margin: 4,
          color: { 
            dark: '#000000',
            light: '#FFFFFF' 
          },
        });

        const link = document.createElement('a');
        link.download = 'qrcode-1200x1200.png';
        link.href = highResQRCode;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('QR Code baixado com sucesso!');
      } catch (error) {
        console.error('Erro ao baixar QR Code:', error);
        toast.error('Erro ao gerar o download do QR Code.');
      }
    } else {
      toast.warning('QR Code ainda não foi gerado. Aguarde um momento.');
    }
  };

  return (
    <Card sx={{ maxWidth: 700, margin: 'auto', mt: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
          Resultados
        </Typography>
        <Divider sx={{ mb: 3 }} />

        {/* URL completa */}
        <Typography variant="subtitle1" fontWeight="bold">URL Parametrizada</Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
          <Link href={results.fullUrl} target="_blank" rel="noopener" sx={{ wordBreak: 'break-word' }}>{results.fullUrl}</Link>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleCopy(results.fullUrl)}
            startIcon={<FileCopyIcon />}
          >
            Copiar
          </Button>
        </Box>
        <Divider sx={{ my: 2 }} />

        {/* URL encurtada */}
        <Typography variant="subtitle1" fontWeight="bold">URL Encurtada</Typography>
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
          <Link href={results.shortUrl} target="_blank" rel="noopener">{results.shortUrl}</Link>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleCopy(results.shortUrl)}
            startIcon={<FileCopyIcon />}
          >
            Copiar
          </Button>
        </Box>
        <Divider sx={{ my: 2 }} />

        {/* QR Code */}
        <Typography variant="subtitle1" fontWeight="bold">QR Code</Typography>
        <Box sx={{ mt: 2, paddingRight: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {qrCodeDataUrl ? (
            <img src={qrCodeDataUrl} alt="QR Code" style={{ maxWidth: '200px', marginLeft: 0 }} />
          ) : (
            <Box sx={{ py: 2 }}>
              {isGenerating ? <CircularProgress /> : <Typography>QR Code não gerado</Typography>}
            </Box>
          )}
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={downloadQRCode}
            startIcon={<DownloadIcon />}
            disabled={!results?.fullUrl}
          >
            Baixar QR Code (1200x1200)
          </Button>
        </Box>
      </CardContent>

    </Card>
  );
};

export default ResultsDisplay;